const FORM_ANCHOR_ID = "form";
const HEADER_SCROLL_OFFSET = 96;

export function scrollToLeadForm(pathname: string, navigate: (href: string) => void): void {
    const path = pathname.split("#")[0] || "/";
    const formHref = `${path}#${FORM_ANCHOR_ID}`;

    if (typeof window === "undefined") {
        navigate(formHref);
        return;
    }

    const isSamePage = window.location.pathname === path;

    if (isSamePage) {
        const formSection = document.getElementById(FORM_ANCHOR_ID);
        if (formSection) {
            const top = formSection.getBoundingClientRect().top + window.scrollY - HEADER_SCROLL_OFFSET;
            window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
            window.history.replaceState(null, "", formHref);
            return;
        }
    }

    navigate(formHref);
}
